// 企业
const json = [
    {
        id: 13,
        tit: '网银互联LinkWAN出席中国（杭州）国际电子商务博览会',
        img: require("../../assets/about/news/qiye/20200920/20200920.png"),

        date: '2020-09-20',
        text: "9月18日-20日，第七届中国（杭州）国际电子商务博览会、2020浙江数字贸易交易会、第十一届浙江商务服务交易博览会在杭州国际博览中心...",
        eassy:
            `
            <p>9月18日-20日，第七届中国（杭州）国际电子商务博览会、2020浙江数字贸易交易会、第十一届浙江商务服务交易博览会在杭州国际博览中心盛大开幕。本届大会由杭州市人民政府、浙江省商务厅主办，以“电商新时代”为主题，本届博览会盛况空前，共有七个展区、8场论坛，以及配套N场小型对接会、沙龙会、闭门会等精准型、高端型活动。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200920/1.png')}" alt="" style="width:600px"></p>
            <p>杭州市政府办公厅一级巡视员何美华在开幕式上介绍，本届电博会将围绕新电商、数字贸易等时下热门话题，挖掘杭州的产业优势资源，充分展示杭州电商新发展、新突破，开展电子商务与数字贸易新发展的深度融合交流，打造一届“打造全球领先的电子商务博览会”。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200920/2.png')}" alt="" style="width:600px"></p>
            <p>在本次活动中，网银互联LinkWAN以其在跨境电商网络生态建设的丰富经验、突出的技术能力和服务能力受邀在中国移动5G第一城，领航新基建展区进行同台展示。网银互联LinkWAN是杭州网银互联科技股份有限公司旗下专注于SD-WAN（软件定义广域网）设计、研发、及服务的业务品牌，助力数字贸易快速发展。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200920/3.png')}" alt="" style="width:600px"></p>
            <p>基于网络即服务（NaaS）的理念，网银互联LinkWAN融合软件定义网络（SDN）及广域网优化技术（WAN Optimization）推出了新一代的SD-WAN解决方案。依托于全球近200个POP节点，构建了一张端到端网络，满足跨境电商客户在快速组网、云网融合、敏捷网络、4G/5G应用、边缘计算、智能调度与管理等方面的个性化服务需求。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200920/4.png')}" alt="" style="width:600px"></p>
            <p>疫情改变了人民的生产生活方式，促进新业态、新消费崛起。今年“电商中国·浙江杭州”实现三会合一，三个展会都已经连续举办多年，已成为国内聚集电子商务和数字贸易产业发展的最具影响力的展会之一，是一次与大数据共舞的盛会，是一次与新科技相拥的盛会，是一次在新商业中创新的盛会，是一次在新格局中践行的盛会，体现了推动浙江向打造“新型贸易中心”的决心和信心。网银互联希望通过本次展会向电商企业展示SD-WAN网络技术，帮助企业降低IT成本，共同助力数字贸易快速发展。</p>
            `
    },
    {
        id: 12,
        tit: '网银互联MDC护航网易云音乐，助力TFBOYS线上演唱会完美播出',
        date: '2020-08-25',
        img: require("../../assets/about/news/qiye/20200825/20200825.png"),

        text: "8月22日晚19:30，TFBOYS七周年演唱会在网易云音乐独家开唱，这也是TFBOYS成军七年以来的首次全线上演唱会。信息显示...",
        eassy:
            `
            <p class="tit" ></p>

            <p>8月22日晚19:30，TFBOYS七周年演唱会在网易云音乐独家开唱，这也是TFBOYS成军七年以来的首次全线上演唱会。信息显示，TFBOYS七周年演唱会售票数破百万；最高同时在线人数达78.6万，<span class="tit">打破线上付费演唱会世界纪录。</span></p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200825/1.png')}" alt="" style="width:600px"></p>
            <p>据介绍，网易云音乐全面主导策划并参与了制作、互动、宣发、周边衍生品开发等线上演唱会全链路流程；还在演唱会内容、技术方面进行创新，将多项国际领先技术融入舞台效果和在线互动环节，打造了这样一场视听盛宴。官方数据显示，8月6日正式开售后，网易云音乐官方即公布24小时售出票数已突破50万张，最终售票数破百万张。而在本次网易云音乐线上演唱会的背后，网银互联浙西智算中心作为网易云音乐的数据服务中心正是本次线上发布会的“主战场”。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200825/2.png')}" alt="" style="width:600px"></p>
            <p>在粉丝和网友们兴奋之时，也是网银互联浙西智算中心运维团队彻夜守候、全面保障之日。8月22日18时30分起，全球各地网友齐聚网易云音乐TFBOYS演唱会直播间，数据流量如开闸洪水般暴增，流量峰值屡创新高。这分分秒秒都在考验网易网络支撑系统，考验通航云MDC数据中心的稳定性及安全性。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200825/3.png')}" alt="" style="width:600px"></p>
            <p>8月末的演唱会，7月初的运维保障。网银互联浙西智算中心早在7月初开始部署本次演唱会的重保工作。公司先后多次召开相关重保工作专题会议，对浙西智算中心进行全面部署安排。所有的运维人员在思想上高度重视，在策略上汲取往期重保经验进行部署安排。并依据线上演唱会特性，在机房供电、环控、消防、安保等各方面都做了周密地统筹规划。</p>
            <p class="tit" >制定整体策略，拟定应急预案</p>
            <p>凡事预则立，不预则废。网银互联MDC一直在如何推动数据中心运维更高质量这条道路上不断求索。无论是小问题，还是大故障，公司都依据各数据中心自身情况，为所有操作制定了详细的应急处理预案，包括但不限于：《极端气象应急预案》、《单/双路市电停电应急预案》、《机房温度异常预案》、《消防应急预案》、《安防应急预案》。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200825/4.png')}" alt="" style="width:600px"></p>
            <p class="tit" >完成关键设备保养，排查各种隐患</p>
            <p>磨刀不误砍柴工，防患胜于救灾。重保工作的首要条件便是确保设备正常稳定工作。因此网银互联浙西智算中心在对重要设备完成安全保障工作后，进行了多次的隐患排查，包括供电、网络、空调、安保、消防等，不放过任何角落。</p>
            <p class="tit" >故障模拟演练，备案措施测试</p>
            <p>为确保直播效果，重保期间，必须全面保障不允许发生任何意外。但万一外市电、运营商上联光纤突然中断怎么办？服务器设备电力负荷突然增加怎么办？室外发生极端天气状况怎么办？对此，网银互联MDC都针对每一种可能发生的故障，按照应急处理预案内容，进行了全面的模拟演习，以保证运维人员面对突发情况可以有条不紊地进行处理。同时，针对UPS后备蓄电池进行了放电测试，以确保意外情况发生时的紧急供电，并针对该情况进行了双路市电停电演练，并提供演练报告。</p>
            <p class="tit" >关键物盘点，补充备品备件</p>
            <p>8月22日，进入备战网易云音乐重保工作倒计时。网银互联浙西智算中心启动了进一步的保障措施。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200825/5.png')}" alt="" style="width:600px"></p>
            <p class="tit" >全区警戒，加强巡检，保障安全</p>
            <p>网银互联MDC数据中心均为7*24小时不间断高效运行，每日机房工程师都要按要求进行定时巡检。本次演唱会重保期间，浙西智算中心的巡检频率提高了数倍，在园区内，安排了多位安保人员再次进行消防隐患排查及周边施工安全巡查；在现场，安排了运营商人员、支撑人员进行值守监测；在UPS、精密空调、柴发厂商等基础设施安排了厂商人员进行现场值守。</p>
            <p class="tit" >“全军突击”，设备全开！</p>
            <p>为了防止设备出现高热、断电等意外情况，网银互联浙西智算中心提前加开了UPS、冷冻泵等设备，确保送风温度在23摄氏度以下，并开启备用空调。从源头上确保了整个数据中心的温湿度在设备高频运行情况下，一直处于正常的温湿度环境。
            网易云音乐数据中心重保工作任务在运维团队全力以赴下，最终取得了圆满成功。网银互联MDC凭借自身实力向客户交出了满意的答卷，也给网友们带来了最佳的观看体验。
            随着演唱会的圆满结束，数据中心的重保工作也完美谢幕。未来，网银互联MDC将以更高标准的基础设施、高品质的服务，继续保障客户的业务持续不间断。</p>
            `
    },
    {
        id: 11,
        tit: '承接5G规模发展，网银互联MDC布局云网，满足企业多元化需求',
        date: '2020-07-28',
        img: require("../../assets/about/news/qiye/20200728/20200728.png"),

        text: "2020年，数据中心正式被列为“新基建”核心领域之一，经济的新“底座”。3月召开的中共中央政治局常务委员会会议明确提出，要加快...",
        eassy:
            `
            <p>2020年，数据中心正式被列为“新基建”核心领域之一，经济的新“底座”。3月召开的中共中央政治局常务委员会会议明确提出，要加快5G网络、数据中心等新型基础设施建设进度。这是近年来，数据中心首次被列入基础建设条目，将给数据中心的建设规模、市场以及技术创新带来新的变化。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200728/1.png')}" alt="" style="width:600px"></p>
            <p class="tit" >移动互联网产业高速发展引发的巨大流量需求</p>
            <p>近年来，随着我国通讯行业逐渐在国际地位上的提升，对基础信息网络的建设投入的不断加大，极大地推动了移动高速网络的发展。从目前移动宽带发展的情况来看，3G/4G用户逐渐趋于饱和，2018年新增1.74亿户，同比下降8.9%，渗透率达到83.4%，而随着5G商用进程的推进，5G渗透率将会提升。            </p>
            <p>随着移动网络用户基数不断扩大，在企业办公、直播视频、网络游戏、生活服务等多种互联网应用产业的高速发展下，用户对移动流量的需求日渐旺盛。5G可以支持0.1～1Gbps的用户体验速率，峰值速率达到数十Gbps。5G的普及将有望进一步刺激用户流量消费的欲望，移动流量或迎来新的爆发期。</p>
            <p>中国移动副总裁简勤曾表示，在2020年中国移动要发展7000万5G用户，并售出1亿台5G手机。与此同时，各大主流终端品牌都陆续发售了5G手机，截止2019年8月已发售5G手机5款，具体为：华为 Mate20 X 5G、中兴 天机Axon 10 Pro 5G、vivo iQOO Pro 5G、三星Galaxy Note10+ 5G、中国移动先行者X1，未来还将有OPPO、一加、小米等各大品牌的5G手机上市。            </p>
            <p class="tit">企业多元化的数据服务需求推动IDC产业4.0</p>
            <p>随着5G时代的来临，产生的数据也越来越庞大，这极大的刺激了IDC产业的发展，并推动IDC向着产业4.0时代迈进。传统的IDC也从基础的主机托管、带宽出租等业务不断与新技术结合（云计算、边缘计算等）拓展到网络安全服务、代维服务、虚拟数据存储和计算等综合化业务。网银互联MDC是网银互联旗下的高端数据中心品牌，其建立源于网银互联在数据中心行业深耕16年的技术沉淀，同时，网银互联MDC的发展也伴随了5G发展的全程。因此，网银互联MDC除传统的托管及带宽出租以外，也从数据中心服务衍生出云、组网、等保、容器等多项增值服务和解决方案，满足了企业客户多元化的IT服务需求。</p>
            <p>2018年，全球IDC业务市场（包括托管业务、CDN业务和公共云 IaaS/PaaS 业务）的总体规模达到 906.2 亿美元，比 2017 年增长 23.6%；据公开数据统计，公共云市场增速接近30%，这是整个市场快速增长的主要原因。网银互联早在2018年启动了云网战略，从原有的IDC服务模式转变成“云原生和云技术+NaaS网络服务+MDC产业”的综合服务商。以云产业布局为例，网银互联MDC目前自建及合作运营的32个城市数据中心，已完成接入阿里云、腾讯云、华为云、亚马逊云等众多全球主流公有云服务商。这极大的满足了企业客户对于云迁移、云部署、云原生服务等需求；同时，这也为网银互联MDC带来了巨大的增值利润。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200728/2.png')}" alt="" style="width:600px"></p>
            <p class="tit" >网银互联MDC - 专注IDC产业十六年</p>
            <p>MDC是网银互联专业专注的工匠精神和全产业链覆盖能力的集中体现。从数据中心的选址、设计、建设、运维、管理、推广、销售以及IT服务和相应的解决方案，网银互联MDC完善了一整套的系统化的标准流程。网银互联MDC已成为金融、政府、大中型互联网企业等行业的不二之选。已建成运营的网银互联MDC十年如一日地不间断地输出了巨大的社会价值。 </p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200728/3.png')}" alt="" style="width:600px"></p>
            <p>网银互联MDC在推出一系列高端数据中心产品的同时，对数据中心建设和运维两项核心能力提供定制化服务。通过提供顾问咨询服务等方式，使业主数据机房达到和网银互联MDC相媲美的建设标准；通过管理服务的商业合作模式，让业主的中大型数据中心机房持续获得MDC同等级别的高品质运行保障。 </p>
            <p>同时网银互联MDC针对客户需求，向数据中心内的客户推出了云、组网、等保、容器等多项增值服务和解决方案，助力客户在数据中心服务的选择上不再局限于基础设施。选择网银互联MDC即是选择了整体IT解决方案！</p>
            `
    },
    {
        id: 10,
        img: '',
        tit: '响应新基建，网银互联启动通航数据中心二期建设，助力区域航天产业发展',
        date: '2020-06-24',
        img: require("../../assets/about/news/qiye/20200624/20200624.png"),

        text: "伴随着互联网行业的继续快速发展，以及5G时代的到来，在“十三五”末，市场对云计算、数据中心的需求将继续呈现出指数型的涨幅...",
        eassy:
            `
            <p>伴随着互联网行业的继续快速发展，以及5G时代的到来，在“十三五”末，市场对云计算、数据中心的需求将继续呈现出指数型的涨幅。近日，MDC浙西智算中心二期已正式启动。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200624/pic1.png')}" alt=""></p>
            <p>2019年年末，中共中央、国务院印发了《长江三角洲区域一体化发展规划纲要》，针对“加快构建新一代信息基础设施，推动信息基础设施达到世界先进水平，建设高速泛在信息网络，共同打造数字长三角”进行战略部署，这给IDC产业及其相关区域经济和行业均提出了创新发展的新命题。</p>
            <p>浙江是人工智能、区块链等前沿技术的一片创新高地，在地利以及人和方面有着得天独厚的优势，同时拥有长江经济带城市群内的数座大城市，在数字长三角格局中将发挥带头引领作用。而MDC浙西智算中心所在的地理位置优越，交通便利，拥有航空、公路、铁路三位一体交通网络体系。目前，该数据中心坐落在浙江核心区域规划航空小镇。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200624/pic2.png')}" alt=""></p>
            <p>在国家政策支持以及社会需求影响下，全国多省市纷纷响应政府号召，杭州网银互联科技股份有限公司与市政府、航空小镇等政府单位签订航天航空信息产业园项目合作协议，MDC浙西智算中心应运而生。该项目为浙江2020年重大产业项目，同时也是市政府向上申报的新基建项目之一，占地面积约31亩，总建筑面积约25000平方米，总投资5亿元，主要用于建设网银互联MDC数据中心、高端办公写字楼和其他综合服务区等基础设施。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200624/pic3.png')}" alt=""></p>
            <p>项目建成后，MDC浙西智算中心将推动园区以5G级别网络传输等作为核心资源，导入云计算、大数据、互联网企业打造浙江核心互联网园区，并设置互联网企业配套生产基地。通过3-5年的运营，将形成区域经济的重要组成部分，又能带动企业和城市环境的协调发展</p>
            <p>机房机柜功率可根据客户需求定制，机柜供电采用双路UPS供电，蓄电池配置时间不小于30分钟；机房采用先进的精密空调制冷，温度控制范围22℃±2℃，湿度控制50%±5%。开发全新DCIM系统，通过将电力监控系统、动力与环境监控系统、BA系统、安防系统、客户业务自助系统等全面结合，完成对数据中心设备和基础设施进行统一监控、科学管理、全方位展示。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200624/pic4.png')}" alt=""></p>
            <p>在政府部门出台有关PUE限制政策以来，绿色节能数据中心成为主流发展趋势，为了响应政府号召打造绿色节能数据中心，MDC浙西智算中心建设中，融入多项创新绿色的环保节能设计，设计运行PUE不大于1.35，实现真正意义上的绿色节能。</p>
            <p>MDC浙西智算中心作为浙江重点大项目，在充足资金、充沛人力、政策优惠护航下，在3个月内完成从奠基到正式投入运营全过程。目前，一期项目数百台机架上的服务器正高速运转，为浙江本地互联网企业的数据储存、交换提供稳定的服务和保障；二期工程预计在2020年底落成，建成后将满足长三角区域数据中心业务发展的生产需要。MDC浙西智算中心建成之后，将为区域内蓬勃发展的数字化产业提供高品质、绿色节能的数据中心服务，并辐射到整个长江经济带。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200624/pic5.png')}" alt=""></p>
            `
    },
    {
        id: 9,
        img: require('../../assets/about/news/qiye/202000408/1.png'),
        tit: '网银互联建言“两会”：开放产业资源入口，垂直化发展智慧城市',
        date: '2020-05-22',
        img: require("../../assets/about/news/qiye/20200522/20200522.png"),
        text: "一年一度的全国两会，已于昨日在北京拉开帷幕。这也是每年3月初召开的全国两会，自1985年以来，首次因重大公共卫生事件推迟到5月...",
        eassy:
            `
            <p>一年一度的全国两会，已于昨日在北京拉开帷幕。这也是每年3月初召开的全国两会，自1985年以来，首次因重大公共卫生事件推迟到5月。疫情冲击后的经济议题，必定是今年两会格外引人瞩目的焦点，来自产业经济一线的企业家代表、委员们对此的观点和声音，当是最为值得倾听的“经济参考”。</p>
            <p>网银互联董事长兼CEO、中国云计算应用联盟常务理事、杭州市计算机信息网络安全协会理事何洪忠今年向全国两会提交两份书面建议，涉及产业资源、智慧城市等热点问题。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200522/1.png')}" alt=""></p>
            <h2 class="tit">一建议：开放产业资源入口</h2>
            <P>建议以《长江三角洲区域一体化发展规划纲要》为指引，鼓励并支持民营企业参与加快信息网络等新型基础设施建设鼓励，为区域内蓬勃发展的数字化产业提供高品质、绿色节能的数据中心服务，建设高速泛在信息网络，共同打造数字长三角。</P>
            <h2 class="tit">二建议：垂直化发展智慧城市</h2>
            <P>推动城市大脑的本地国有企业承载，城市民生数据庞大且敏感，应加大新基建的投入，承载数字城市建设。且搭建涉及民生的各类专有云，如燃气云、水务云、公交云等等，各朵云之间与城市大脑通过新技术专网打通。</P>
            <P>传统产业数字化转型需要更多专业化的数字基础设施支撑。而这正是网银互联独有的核心优势，网银互联依托工业互联网等前沿技术，立足全国32座城市的数据中心集群及遍布全球200多个网络POP点，提供一站式企业IT解决方案，支撑多领域企业和政府机关数字化转型升级。</P>
            <P>通过对疫情后的客户回访，网银互联深刻的认识到企业的诉求困难和发展瓶颈，这坚定了网银互联搭建企业级IT服务平台的决心。</P>
            <P>数字经济是充满活力的未来新经济，产业互联网是中国经济发展的新动能。接下来，网银互联将加快创新体系的能力建设，以开放心态携手各界伙伴，全面助力全球企业客户走向数字化、智能化，共振经济！</P>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/20200522/2.png')}" alt=""></p>
            <P> 杭州网银互联科技股份有限公司成立于2004年，是一家致力于提供企业级IT管理服务的高新技术企业。总部位于中国杭州，并在上海、深圳、北京、香港等地设有分支机构，主要业务范围包括IDC基础设施、云计算、全球网络通讯等领域。</P>
            <P>网银互联通过自建分布式数据中心和全球网络节点，与全球通信运营商、公有云厂商实现资源互联，形成自主创新的云网融合管理平台，为客户提供IDC订制、服务器托管、混合云DC、容器云、SD-WAN、云数据同步服务、IDC数据同步服务等产品和服务，确保开发、测试、应用发布等生产环境流程的敏捷、高效、安全，帮助企业数字化转型，实现企业IT向业务的赋能。</P>




            `
    },
    {
        id: 8,
        img: require("../../assets/about/news/qiye/202000408/20200408.png"),
        tit: 'IDC十年，朝着技术的长征',
        date: '2020-04-08',
        text: "《IDC十年，朝着技术的长征》--过去十年，是中国互联网用户暴增的十年。3G的加速和4G的降价伴随着移动互联网技术的兴起，为全球带来价格低廉的...",
        eassy:
            `
            <p>过去十年，是中国互联网用户暴增的十年。3G的加速和4G的降价伴随着移动互联网技术的兴起，为全球带来价格低廉的数据连接和信息处理能力。今年的4月8日是网银互联这家立足浙江本土的知名IDC公司成立十六周年的纪念日，这家老牌IDC企业无疑见证了这十年来互联网技术和信息技术的发展。风雨十数载，可以讲的故事有很多。无论是盈利模式的选择，客户群体的变化，或者是产品的更新换代，都比不上从业务的角度来看技术选择更有意思，——技术的故事藏得深并且鲜为人知，然而特别具有时代的特征。</p>
            <p>IDC行业作为互联网行业的IT服务供应商，其技术发展趋势由于紧跟客户的需求而呈现出IT技术的时代轨迹。作为一家“  <span style="font-weight:bold">一切以客户为中心</span>”为核心价值观的企业，网银互联一直在满足客户需求上绞尽脑汁。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/202000408/1.png')}" alt=""></p>
            <h2 class="tit">从关心客户的业务连续性到关心客户的业务敏捷性</h2>
            <P>2010年第三方外包IDC迅速崛起，不仅为互联网企业提供了安全可靠的基础设施环境，还提供了数据传输服务和高速接入服务。以网银互联为例，其提供的服务有机柜、机位的出租，多种运营商带宽、IP、系统维护（系统配置、数据备份、故障排查）以及其他支撑类代运维服务。为了提升机房本身的竞争力和解决客户的运维痛点，网银互联一直致力于提升以物理设备为中心的技术服务能力——通过专业的工程设计能力、电源和制冷技术，来实现1.4以下的PUE，并通过对于硬件的全面自动化的运维监控和管理来完成对客户SLA的服务承诺。</P>
            <p>而作为互联网客户的基础设施服务商，最为关注的是云计算带来的数据中心的新的交付模式。这里有一段网银互联公司历史上的小小插曲，却为后续的技术转型奠定了基础。</p>
            <p>对于云计算带来的“物理设备的去形式化”的颠覆型变革，网银互联早在2011年就预见到了这场技术盛宴的即将开幕，并组建了一个十几个人的初创团队开始对于公有云平台的研发。与此同时，果断地调整了机房建设思路，对于机房采取分步建造的模式，留出白空间为客户解决私有云的定制化需求</p>
            <p>网银互联在2013年推出了基于KVM的LinkCloud的公有云平台，使用C，Java，PHP语言实现在线自助购买云服务器，通过调用libvirt API控制虚拟机，获得了2万个的注册用户，5000个的活跃用户，开通了2000多台云服务器。</p>
            <p>然而，市场上公有云的发展速度超出预期。亚马逊、阿里云、微软等大小云计算公司相继展开大规模的价格竞争。</p>
            <p>以家门口的阿里巴巴为例，这样的计算密集型企业本身拥有庞大的数据中心，可以在满足公司内部服务的同时，让其他公司来分享计算能力和资源，其建立生态的速度是相当惊人的。可以看到，2014年双十一时，阿里仍纠结是否要把服务器切换到上海的数据中心。到了2015年时，阿里已经在深圳、张北和上海同时启用了数据中心。同时，把数据放在云上的比例也越来越大，从10%到65%，“底层的架构改变每年都在发生”。
            网银互联陷入了“成为没有议价能力的阿里云的DC供应商”或者是“以亏损模式与阿里云正面竞争”的两难境地。</p>
            <p>经过认真思考，管理团队果断选择了第三个方案——走独立第三方IDC之路，并成为公有云的合作伙伴，保持在云计算技术上的与时俱进。</p>
            <p>RightScale 云状态报告显示：81%的受访企业采用多云，其中混合云的比例高达51%。混合云俨然已成为云计算领域的主流趋势。</p>
            <p>从物理机到云，网银互联为客户提供混合云的资源环境和快速部署的解决方案。客户可以根据自身信息安全的要求、现有基础设施的状况，以及业务上的云服务需求，来灵活搭建。几乎所有的销售人员和运维人员都考取了阿里云的ACP证书，实施交付部门甚至考取了阿里云、AWS的高级架构师证书。网银互联的售前人员为客户提供上公有云的架构设计、资源选型和迁移服务，并为客户提供私有云代维和云上云下的连接。所提供的代维业务也从原来传统的web型应用转为集群级、微服务化集群级的应用维护。通过这些服务来支持客户部署由软件定义的数据中心，实现客户对于业务敏捷和降低成本的要求。</p>
            <h2 class="tit">从OPENSTACK到容器技术</h2>
            <p>容器技术可以对已有资源进行更高级别的抽象，为不同主机上运行服务提供一个轻便的、一致的封装，使开发、运维工作变得更快速、简单、轻量级。</p>
            <p>在2018年之前，大部分需要网银互联为之提供虚拟化服务的客户采用openstack技术，而近年来随着容器技术的逐渐成熟落地，越来越多的客户开始尝试使用容器。事实上，早在2017年网银互联就敏锐地发现openstack已经出现这种没落的征兆，经过长期对容器技术的关注，毅然选择了K8S的技术分支，原因是其信赖其基于Google技术,后面也验证了选择的正确性。</p>
            <p>网银互联的客户的主要场景为混合云架构。网银互联针对客户需求开发了基于容器和K8S的混合云平台，可以在存储领域发挥特别的作用——意味着利用公有云存储和本地存储来实现更高的整体价值，而且在一个区域出现故障时，可以自动把系统（尤其是有状态应用）迁移到另一侧。当云计算资源出现私有云与公有云过载的危机时，管理员有能力转移工作量是评判混合云数据中心是否敏捷的标准。</p>
            <p>2019年下半年网银互联的容器团队正式发布了Linkcloud品牌旗下容器魔方云平台，以PaaS模式向客户交付。其主要技术优势在于：1. 容器化流水线的缓存技术，解决流水线效率低下的问题；2. 分布式块存储技术，可发展为独立的存储产品，同时解决混合云热存储迁移问题；3. 混合云管理技术（包括网络、存储在内的系统）实现云服务的高可用。</p>
            <p>与此同时，k8s技术在网银互联从开发到运维均能熟练掌握，不仅向客户提供标准化容器产品，也能向客户输出容器化运维服务。
            而网银互联自研的SD-WAN产品也是完全架构在k8s基础上以云原生的方式开发、测试和生产。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/202000408/2.png')}" alt=""></p>
            <h2 class="tit">从服务器虚拟化到网络虚拟化</h2>
            <p>如果不去向虚拟化技术方向不断前进，公司研发部或许将一直开发一些自用工具。如流量攻击预警、未备案阻断、流量采集、日志分析系统、全国网络质量监控系统等，都是自研自用的。</p>
            <p>但是从传统物理机到虚拟机的技术跨越，使公司在技术战略上明确了拥抱云化的思想。由于服务器虚拟化对数据中心产生了重大影响，所以虚拟网络必须提到议事日程上来。</p>
            <p>对于虚拟化技术的不断研究和实践，以及对于存储和网络的开源技术的原理研究和技术积累，使得公司在开发“软件定义的通信级网络产品”——LinkWAN时，毫不费力，轻松解决了虚拟网络中隔离机制、分布式路由等理念问题。</p>
            <P>网银互联的首席架构师何晓波提到这是一款基于SDN技术的软件与硬件结合的通信级产品。协议基于内部私有协议。而产品理念与大部分硬件厂商（如思科）的SD-WAN产品不同，尽量淡化硬件功能，并在云端处理、进行应用加速，通信更高速稳定。这一点上与国外目前市场占有率很高的Aryaka公司不谋而合。</P>
            <P>网银互联主要采用了以下几种技术：1. 自研SDN控制器；2.NFV技术：所有的IP数据转发都基于虚拟路由器，包括控制平面，数据转发平面，部分设计理念源自openstack的Neutron，但是实现技术主要借助Linux VRF技术做3层网络的安全隔离，VXLAN技术作为2层网络的安全隔离，完整的实现VPC（virtual private cloud)；依靠自研的SDN控制器来做2-3层的数据转发策略，安全策略；3.嵌入式软件系统：深度定制自己的硬件系统，依靠开源的openwrt定制自己CPE的OS系统。</P>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/202000408/3.png')}" alt=""></p>
            <P>LinkWAN网络产品的问世，表达了公司创始人对于网络世界变革的理想。公司把软件定义网络的平台取名为Gaia（盖亚），将终端设备CPE取名为base（基地），就是借世界著名科幻小说《基地》三部曲来表达网络工程师们想要用全新的组织方式，构建理想中的新的网络世界，让更多的数据从传统的网络过渡到全新的网络中来。</P>

            <h2 class="tit">从技术匹配业务转向技术拉动业务</h2>
            <P>在云计算运维领域的成长，使得技术人员不断开发出新的服务交付类产品。 考虑到数据中心内广大客户对安全的需求以及对国家要求的信息等级保护认证的需求，系统运维部门在下沙数据中心和福地数据中心搭建了与知名安全产品供应商“深信服“合作的安全资源池。池化的软件资源，以按需计费多租户模式供数据中心内的客户使用。将安全资源池与客户的应用和网络层面的打通并熟练配置，考验了交付人员对于安全、系统和网络的综合技术能力。</P>
            <P>另一个技术拉动业务的例子是网银互联自研的BOSS系统，将在今年6月底上线。这是一个自助式服务平台，客户可以在网页端自助采购IDC资源和公司其他产品，客户可以自助下工单，自主监控，电子化签约和出账，公司还通过boss系统向客户提供托管报告和其他优化建议。这样的自研产品极度考验公司本身对自有业务流程的规范化梳理能力和软件产品的打造能力。BOSS平台将为网银互联已有的上千个客户提供更加优质的客户服务，并形成流量池，从而提升客户的留存率和复购率。</P>
            <p style="text-align: center"><img src="${require('../../assets/about/news/qiye/202000408/4.png')}" alt=""></p>
            <h2 class="tit">从OA到全面数字化</h2>

            <P>网银互联研发团队中的大部分人都来自优秀的公司，具有在行业内处于领先水平的研发能力和产品认知能力。公司采用考核加激励的方式，通过Jira系统的规范使用来控制产品的开发和测试质量，通过知识管理和分享系统来提升大家的协同水平，提倡工程师文化，并通过标准的职位发展体系和OKR目标管理体系来激励大家的上进心。同时，公司致力于数字化转型，也为很多传统客户的信息化提供数据中台的咨询服务。</P>
            <P>网银互联的核心业务系统开发于10年前，被公司内部称之为“OA”，实则为订单系统和资源管理系统的简单合并。由于数据库结构十分笨重，且界面不友好，一直被诟病。网银互联从2018年开始着手对业务系统进行整改，重新解构数据，梳理业务流程，使其成为一个更加符合IDC业务需求的ERP系统，与办公审批、业务前台、CRM系统、运维系统、工单系统和财务系统实现全面的对接和数据的灵活使用。</P>
            <P>从技术路径来看， 网银互联会以IT管理为主要方向，在资源虚拟化和服务自动化技术上持续投入，不断提升IT管理的服务交付能力。不惧怕技术的颠覆，永远以客户的需求为导向，一切为了IT更自由。</P>

            `
    },

    {
        id: 7,
        img: require("../../assets/about/news/qiye/20200227.png"),
        tit: 'IDC老司机如何防患人为“拔电源、剪光纤”等暴力“删库”事件',
        date: '2020-02-27',

        text: "《IDC老司机如何防患人为“拔电源、剪光纤”等暴力“删库”事件》-- 不知道大家的朋友圈，有没被近期运维人员恶意删库事件刷屏了。这次的故障...",
        eassy:
            `
            <p>不知道大家的朋友圈，有没被近期运维人员恶意删库事件刷屏了。这次的故障已超过36小时，仍未完全恢复。据悉，该公司的业务系统数据库（包括主备）遭遇其公司运维人员的删除，目前技术团队正在努力恢复数据中。</p>
            <p>目前对新用户服务已经恢复正常，但老用户数据官方预计要到2月28日才有结果。</p>
            <span style="display: block">归纳了两个比较常见的疑惑</span>
            <span style="display: block">1. 为什么数据恢复会花这么长时间？</span>
            <p>这次故障极有可能是直接做了rm -rf或者fdisk这样的基本不可逆转文件删除操作，业务系统数据库（包括主备）一起被极端删除。</p>
            <p>再加上数据库备份没有备份或者仅有全量备份，无增量备份。导致没有可快速恢复的备份，数据恢复耗时超长。</p>
            <span style="display: block">2. 运维人员的权限怎么会这么大？</span>
            <p>对于绝大多数中小型企业来说，一下招很多运维/DBA，人力成本过高。目前普遍现象是，一个运维或许就可以管理整个系统，并拥有系统主机最大权限。</p>
            <p>总而言之，运维人员权限太大，并做了极端操作，又没有好的备份机制恢复，所以造成了此次极端恶劣的故障和影响。</p>
            <p>这不是第一次有公司遭遇内部员工“删库跑路”事件网银互联作为IDC老司机是如何避免“拔电源、剪光纤”这样灾难性故障的呢？</p>
            <p style="text-align: center">网银互联各大运维模块一直坚持以下规则</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.2.27/2.jpg')}" alt=""></p>
            <span>问：日常运维系统，有员工赌气，对重要业务删改怎么办？<br />
               答：不能实现。因为网银互联所有运维人员操作业务系统均需通过堡垒机进行登陆操作，涉及重要业务的删改操作，审核通过后通过堡垒机授予临时的操作权限。操作完成或授权时间到期权限回收。
            </span>
            <span>问：核心数据被误删了，能快速恢复吗？<br />
               答：可以。网银互联关键核心业务数据在存储介质上采用了跨机房分布式存储系统进行数据存储，另外业务数据或备份数据均采用加密存储，部分数据在用户查询或信息公开时进行数据脱敏处理。数据备份采用混合多副本方式，云上云下异地备份，不同备份介质的权限分别交由A\\B不同员工。
            </span>
            <span>问：数据存在被拖库数据暴露的风险吗？<br />
               答：不会，业务数据或备份数据均采用加密存储，部分数据在用户查询或信息公开时进行数据脱敏处理。即使被脱库数据信息同样无法被获取。
            </span>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.2.27/3.jpg')}" alt=""></p>
             <span>问：有员工情绪不好，恶意拔了电源线怎么办？<br />
              答：不可能出现这种情况。网银互联严格执行双人工作制。照电气维护原则，巡检、维护等所有工作，都需一人操作一人审核，防止出现违规操作。
            </span>
            <span>问：员工会不会出现误操作？<br />
              答：不会。网银互联具有完备的流程体系，每一步操作都需要专员审核。并实行操作票制，实行事前方案，事中确认，事后复核。
            </span>
            <span>问：没有预约可以进入机房吗？<br />
              不能。园区门禁严格管控，外来人员需报备并通过全面审核后，出示公司证明方可进入指定区域，并由网银互联工作人员全程陪同，我们会登记每一步操作。
            </span>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.2.27/4.jpg')}" alt=""></p>
            <span>问：员工情绪不佳，想进入网络设备核心间搞破坏怎么办？<br />
              答：核心设备处于核心间，与客户设备隔离，机房运维人员进入核心间必须采取双人工作制，并且双人都需机房主管、网络部经理审核授权。并且核心路由器非高级工程师权限不能操作，且高级工程师操作需要1+1审核，保证安全性。
            </span>
             <span>问：网络设备是否备份，备份方式是什么？<br />
              答：设备配置备份在部门间实行双重交叉备份双轨制，A部门员工无法修改备份至B部门的A部门配置文件系统，即采用2套完全不同的加密方式；备份周期均为每日全量备份。
            </span>
             <span>问：操作权限与责任制如何管理呢？<br />
              答：设备登录管理实行多层级权限区分，任意级别工程师对设备的操作需由上一级进行审核。工程师做变更操作需通过权限审核，否则不能操作；通过3A认证保证一人一账号，记录变更操作全过程。
            </span>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020.2.27/5.jpg')}" alt=""></p>
            <span style="display: block">■ 我司定期组织员工普法教育，以提升员工法律意识</span>
            <span style="display: block">■ 对公司、团队近期大事件，如年度考评、重大过失、客户投诉等，第一时间配合上级主管对当事人进行心理疏导，确保人员情绪稳定</span>
            <span style="display: block">■ 不断输出企业文化宣导，通过定期对正道，同行，有担当的价值观评估结果复盘</span>
            `
    },
    {
        id: 6,
        img: require("../../assets/about/news/qiye/20200207.png"),
        tit: '一切为了保障先行，一切为了IT更自由|网银互联是抗击疫情的背后英雄',
        date: '2020-02-07',
        text: "《一切为了保障先行，一切为了IT更自由|网银互联是抗击疫情的背后英雄》-- 网银互联为各行业企业在疫情期间提供以“保障为先”的云计算与企业组网...",
        eassy:
            `
            <p>网银互联为各行业企业在疫情期间提供以“保障为先”的云计算与企业组网服务。凭借快速、灵活、可靠的解决方案为客户提供针对突发业务的响应。</p>
            <p>国内大型医疗用品生产商稳健医疗用品股份有限公司（以下简称“稳健医疗”）从2019年12月起就已经开始同疫情赛跑。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020-2.7/2.jpg')}" alt=""></p>
            <p>不知道稳健医疗？</p>
            <p>那一定听说过全棉时代吧！</p>
            <p>其集团动员黄冈、嘉鱼、崇阳三地分公司工厂全体人员放弃休假，加班加点生产医用防护物资，总共为社会提供超过1亿只医用口罩和11万件防护服。
    一家“先知先觉”口罩生产商和疫情的赛跑：部分员工在家隔离，其他员工24小时生产。</p>
            <p>一切为了保障先行，一切为了IT更自由</p>
            <p>网银互联在客户需求的第一时间 ，为其提供了免费的SD-WAN组网产品与服务，至今已有3个多月。网银互联为企业助力，为祖国加油！</p>
            `
    },
    {
        id: 5,
        img: require('../../assets/about/news/2020-1.31/1.jpg'),
        tit: '众志成城，共防疫情！网银互联7*24小时全方位值守，支撑企业客户业务正常运行！',
        date: '2020-01-31',
        text: "众志成城，共防疫情！网银互联7*24小时全方位值守，支撑企业客户业务正常运行...",
        eassy:
            `
            <p style="text-align: center"><img src="${require('../../assets/about/news/2020-1.31/2.jpg')}" alt=""></p>
            `
    },
    {
        id: 4,
        img: require("../../assets/about/news/qiye/20200116.png"),
        tit: '齐心齐力，挑战2020>|网银互联2020年度盛典圆满举行',
        date: '2020-01-16',
        text: "齐心齐力，挑战2020>|网银互联2020年度盛典圆满举行...",
        eassy:
            `
            <p style="text-align: center"><img  src="${require('../../assets/about/news/1.16/2.jpg')}" alt=""></p>
            `
    },
    {
        id: 3,
        img: require("../../assets/about/news/qiye/20191017.png"),
        tit: "网银互联荣获智云奖——2019年度最佳云服务提供商",
        text: "企业数字化的时代已经来临，各行业面临智能化、云端化的升级。工信部印发了《推动企业上云实施指南(2018-2020...",
        date: "2019-10-17",
        eassy:
            `
            <p>企业数字化的时代已经来临，各行业面临智能化、云端化的升级。工信部印发了《推动企业上云实施指南(2018-2020年)》，从实施上云路径、强化政策保障、完善支撑服务等层面为推进企业上云提出了指导。业务云化越来越成为企业需要迫切思考的问题。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/news1017.png')}"></p>
            <p>10月15日，由中国云体系产业创新战略联盟、上海市软件行业协会、国际云安全联盟和拓普会展主办的第二届企业云服务大会在上海举行，大会邀请了数百名企业CIO和信息化负责人，围绕云计算发展趋势及实践、企业上云转型应用、数智赋能产业升级等话题，分享经验和理念，探索前沿和未来。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/news1017a.png')}"></p>
            <p>在本次企业云服务大会上，由上海市软件行业协会秘书长杨根兴为网银互联颁发智云奖“2019年度最佳云服务提供商”。此殊荣经产业联盟、行业协会、媒体等机构严格甄选而出，是对网银互联产品与服务的肯定。</p>
            <p>网银互联凭借专业服务能力、多云管理能力和企业组网能力，为企业提供云咨询、云迁移、云管理和云应用全生命周期云管理服务，帮助企业解决技术选型、架构设计、风险评估、上云迁移、资源编排、智能监控等难题，轻松实现业务云化，搭建敏捷、高效、经济的云化IT架构。</p>
            <p style="text-align: center"><img src="${require('../../assets/about/news/news1017b.png')}"></p>
            <p>在2019年，网银互联已为电商、教育、大数据、互联网、金融等多个行业数十家企业提供专业云服务。此次，网银互联荣获“2019年度最佳云服务提供商”，将激励着我们继续打磨产品、提升服务，帮助更多的客户上好云、用好云和管好云。</p>
           `
    },
    {
        id: 2,
        tit: "云栖大会 | 网银互联晒亮眼成绩单",
        text: "9月25日-27日，由阿里巴巴主办的云栖大会在杭州举行。今年云栖大会主打“数.智”两字，其中包括了四大“秘密武器”...",
        date: "2019-09-30",
        img: require("../../assets/about/news/qiye/20190925.png"),
        eassy:
            `
        <p>9月25日-27日，由阿里巴巴主办的云栖大会在杭州举行。今年云栖大会主打“数.智”两字，其中包括了四大“秘密武器”，即：云、大数据、智联网、以及移动协同。</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/news0930a.jpg')}" alt=""></p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/news0930b.jpg')}" alt=""></p>
        <p style="text-align: center">现场盛况</p>
        <p>在数字经济时代，网银互联围绕“云+网"、"IaaS+PaaS”的核心理念，带着三大产品亮相云栖大会，引发关注</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/news0930c.jpg')}" alt=""></p>
        <p style="text-align: center">网银互联展台人潮涌动</p>
        <p>三大技术亮点，用户可现场体验,魔方云容器PaaS平台/LinkCloud多云管理平台、SD-WAN全球网络智能传</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/news0930d.jpg')}" alt=""></p>
        <p style="text-align: center">用户与产品总监零距离面对面沟通交流</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/news0930e.jpg')}" alt=""></p>
        <p style="text-align: center">摘下阿里云飞天合作联盟：华东区域一级经销商</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/news0930f.jpg')}" alt=""></p>
        <p style="text-align: center">明珠新闻采访网银互联市场总监</p>
        <p style="text-align: center"><img src="${require('../../assets/about/news/news0930g.jpg')}" alt=""></p>
        <p style="text-align: center">吸睛力十足</p>
        <p>云栖大会期间，网银互联公众号新增关注：800+潜在客户：200+已在推进客户：50+今后，网银互联将以全新的产品架构展开云网融合新模式，持续集成优质资源，共建良好生态，为企业数字化转型提供最贴合的方案与优质服务。</p>
           `
    },
    {
        id: 1,
        tit: "云栖大会 | 网银互联成功拿下阿里云华东区域一级经销商！",
        text: "9月25日，阿里云全球生态事业部总裁沈涛在云栖大会上，正式授权网银互联成为华东大区一级经销商，这标志着网银在...",
        date: "2019-09-25",
        img: require("../../assets/about/news/qiye/20190930.png"),
        eassy:
            `
    <p>9月25日，阿里云全球生态事业部总裁沈涛在云栖大会上，正式授权网银互联成为华东大区一级经销商，这标志着网银在市场拓展、技术能力上均已进入了一个全新阶段。</p>
    <p>目前云计算已经是大势所趋，无论是云原生的新型互联网企业，还是传统企业的数字化云转型，
    都离不开专业的云托管和云集成服务。网银互联作为优质的Cloud MSP,并依托全方位云解决方案，在私有云、
    公有云、混合云、容器等综合性大型云项目交付领域有丰富经验。</p>
    <p style="text-align: center"><img src="${require('../../assets/about/news/news0925a.jpg')}" alt=""></p>
    <p style="text-align: center"><img src="${require('../../assets/about/news/news0925b.jpg')}" alt=""></p>
    <p style="text-align: center">阿里云经销商等级评定是对经销商销售市占率、客户满意度、服务管理能力等的综合评价，阿里云一级经销商全国仅有16家。</p>
    <p style="text-align: center"><img src="${require('../../assets/about/news/news0930e.jpg')}" alt=""></p>
    <p style="text-align: center">图：阿里云全球生态事业部总裁沈涛为网银互联云事业部总经理许琴颁发证书</p>
    <p>网银互联作为华东区域的能力中心，拥有阿里云全品类销售权限，累积服务2000+企业客户。接下来，我们将继续为企业提供专业的服务及优质的资源，使客户价值最大化。</p>
           `
    },
    {
        id: 0,
        tit: "网银互联亮相华为云城市峰会･选择不凡",
        text: "杭城，在近十年来，以不凡实力，铸就了繁荣的数字经济。5月9日，“杭州･选择不凡，华为云城市峰会2019”在杭州举行...",
        date: "2019-05-10",
        img: require("../../assets/about/news/qiye/20190510.png"),
        eassy:
            `
        <p>杭城，在近十年来，以不凡实力，铸就了繁荣的数字经济。5月9日，“杭州･选择不凡，华为云城市峰会2019”在杭州举行。随着云计算的进一步发展，产业数字化进程正在加速，越来越多的企业将其业务放到云端去深化。所以，此次大会结合了杭州产业发展特色，聚焦新金融、互联网和软件开发等行业。</p>
        <p>大会上华为云提出了Cloud+X的概念，认为云计算目前处于2.0时代，未来将成为企业的数字化底座，因此企业上云不仅仅需要考虑计算，还要考虑人工智能、联接、IoT、5G、芯片、消费终端、生态等一系列因素。华为云将继续踏踏实实地用领先全栈全场景AI服务政企客户，帮助客户释放生产力潜能。</p>
        <p>网银互联作为华为云的深度合作伙伴，亮相于此次华为云峰会。为展会嘉宾带来了混合云解决方案，该方案充分整合了华为云和网银互联的各自优势。华为云拥有丰富的产品线，包括公有云、私有云、存储、服务器以及网络等等，而网银互联能与公有云形成天然互补，就在于其优质的数据中心托管资源和多层面网络互联互通的整体资源池。同时，深度的行业积累让网银互联懂IT，更懂企业客户，用具体的解决方案真实有效地去解决客户的问题；优质的技术服务能力将最适合的混合环境资源带给客户，高效落地，助力转型。</p>
        <p>网银互联高级副总经理许琴还进行了主题演讲——联合打造混合云解决方案，让企业上云更自主.表示网银互联将作为专业的MSP，为用户提一站式混合云解决方案。基于网银互联15年丰富运营经验，针对混合云的业务特点，建立了专职的专家团队，全职负责混合云的咨询、实施、优化、运维等服务，覆盖售前、售中、售后整个周期。</p>
        <p>网易互联正在凭借专业的技术和领先的服务理念让用户专注业务发展，连接企业的现在与未来。</p>
           `
    }
]

export default json;



// WEBPACK FOOTER //
// ./src/view/about/newinfosB.js